export default "__VITE_ASSET__BTA_WJnv__"